



















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AclMember } from "@/services/security/types";
import SolutionAccessModal from "@/components/solutions/modals/SolutionAccessModal.vue";
import { solutionAccessFields } from "@/components/solutions/fields/solutionAccessFields";

@Component({
    components: { BoardAccessModal: SolutionAccessModal }
})
export default class SolutionAccess extends Vue {
    @Prop() acl!: AclMember[];
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localAcl = [] as AclMember[];
    fields = solutionAccessFields;
    searchQuery = ""

    @Watch("acl")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localAcl = this.acl;
    }

    // lifecycle hooks
    mounted() {
        this.localAcl = this.acl;
        this.localCollapseState = this.collapseState;
    }

    // computed
    get filteredData() {
        return this.localAcl && this.localAcl
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    x.username.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // methods
    promptAddSolutionAccess() {
        (this.$refs.boardAccessModal as any).open();
    }

    removeAccess(id: string) {
        const item = this.localAcl.find(x => x.id === id);
        if (!item) {
            return;
        }
        this.localAcl.splice(this.localAcl.indexOf(item), 1);
    }

    onAccessUpdated(data: AclMember[]) {
        this.localAcl = data;
    }

    emitData() {
        // deep copy to avoid binding
        this.$emit("accessUpdated", JSON.parse(JSON.stringify(this.localAcl)));
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "SolutionAccess.vue", state: state });
    }
}
